import React from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  Calendar,
  Bed,
  Gift,
  Coffee,
  Star,
  GlobeSimple,
  MapPin,
  SignOut,
  House,
} from "@phosphor-icons/react";
import { useAuth } from "../../context/AuthContext";

const NAV = [
  { to: "/admin", icon: Calendar, label: "Prenotazioni", end: true },
  { to: "/admin/rooms", icon: Bed, label: "Camere" },
  { to: "/admin/offers", icon: Gift, label: "Offerte" },
  { to: "/admin/services", icon: Coffee, label: "Servizi" },
  { to: "/admin/experiences", icon: MapPin, label: "Esperienze" },
  { to: "/admin/reviews", icon: Star, label: "Recensioni" },
  { to: "/admin/settings", icon: GlobeSimple, label: "Impostazioni" },
];

function SidebarItem({ to, icon: Icon, label, end }) {
  return (
    <NavLink
      to={to}
      end={end}
      data-testid={`admin-nav-${label.toLowerCase()}`}
      className={({ isActive }) =>
        [
          "flex items-center gap-3 px-4 py-3 text-sm transition-colors",
          "border-l-2",
          isActive
            ? "border-[#C5A059] text-[#FFFFF0] bg-white/[0.03]"
            : "border-transparent text-white/50 hover:text-white/80 hover:bg-white/[0.02]",
        ].join(" ")
      }
    >
      <Icon size={18} weight="light" />
      <span>{label}</span>
    </NavLink>
  );
}

export default function AdminLayout() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = () => {
    logout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#09090b] text-[#FFFFF0] flex" data-testid="admin-layout">
      {/* Sidebar */}
      <aside className="w-64 shrink-0 border-r border-white/10 flex flex-col">
        <div className="px-6 py-8 border-b border-white/10">
          <div className="text-xs uppercase tracking-[0.25em] text-[#C5A059] mb-1">
            Admin
          </div>
          <div className="font-serif text-2xl leading-tight">Alpi Resort</div>
        </div>

        <nav className="flex-1 py-4">
          {NAV.map((item) => (
            <SidebarItem key={item.to} {...item} />
          ))}
        </nav>

        <div className="p-4 border-t border-white/10 space-y-1">
          <Link
            to="/it"
            className="flex items-center gap-3 px-4 py-2 text-sm text-white/50 hover:text-white/80 transition-colors"
          >
            <House size={16} weight="light" />
            <span>Vai al sito</span>
          </Link>
          <button
            onClick={onLogout}
            data-testid="admin-logout"
            className="w-full flex items-center gap-3 px-4 py-2 text-sm text-white/50 hover:text-white/80 transition-colors text-left"
          >
            <SignOut size={16} weight="light" />
            <span>Logout</span>
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
